/**
 * fail-open lets ad-blocker users bypass maintenance if LD init is blocked.
 * Use only after the maintenance window.
 */

import { useEffect } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import {
  hasMaintenanceOverride,
  isMaintenanceModeFlagActive,
  setMaintenanceModeFlagValue,
  setMaintenanceModeUnavailable,
} from "shared-utils";

import { FEATURE_FLAGS } from "../launchDarkly/utils";

export const useMaintenanceMode = () => {
  const flagValue = useFlags()?.[FEATURE_FLAGS.MaintenanceMode];

  useEffect(() => {
    setMaintenanceModeUnavailable(false);
  }, []);

  useEffect(() => {
    setMaintenanceModeFlagValue(flagValue);
  }, [flagValue]);

  return {
    isMaintenanceModeActive:
      !hasMaintenanceOverride() && isMaintenanceModeFlagActive(flagValue),
    isLoading: false,
    isMaintenanceModeFlagActive: isMaintenanceModeFlagActive(flagValue),
  };
};
